<template>
  <div
    :class="[
      'order-detail-textarea',
      { 'textarea-expansion': isTextareaFullscreen },
      { 'is-over': isOver }
    ]"
    data-automation="OrderDetailTextarea"
  >
    <div class="detail-textarea-box">
      <div class="order-detail-textarea-header">
        <ux-button plain text @click="changeExpansion">
          <i
            :class="
              isTextareaFullscreen ? 'ux_icon_fullscreen_shrink' : 'ux_icon_fullscreen_expand'
            "
          ></i>
        </ux-button>
      </div>

      <i class="textarea-divider"></i>

      <!-- 输入框 -->
      <div class="detail-textarea-inputbox" v-if="showTextareaInputbox">
        <ux-input
          v-model="textareaVal"
          show-word-limit
          type="textarea"
          resize="none"
          :placeholder="textareaPlaceholder"
          :maxlength="1000"
          :autosize="autosize"
        ></ux-input>
      </div>

      <!-- 底部 -->
      <div class="detail-textarea-footer">
        <!-- 图片列表 -->
        <ux-upload
          v-if="!isOver"
          class="detail-textarea-upload"
          type="image"
          accept="image/jpeg, image/png, image/gif"
          :list="uploadImgList"
          :exceed="exceed"
          :limit="3"
          :size="1024 * 3"
        ></ux-upload>

        <div class="detail-textarea-footer-btns" v-if="!isOver">
          <ux-button type="primary" plain v-if="isShowOverBtn" @click="onClickOver"
            >{{$t('HT.orderDetail.overOrder')}}</ux-button
          >
          <ux-button type="primary" @click="onClickSend">{{this.$t('HT.orderDetail.send')}}</ux-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OSS from 'ali-oss';

export default {
  name: 'OrderDetailTextarea',
  components: {},
  props: {
    // 展开全部
    isExpansion: {
      type: Boolean,
      default: false
    },
    // 基础信息
    orderInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isUser: {
      type: Boolean,
      default: true
    },
    // 订单状态
    orderStatus: {
      type: Number | String,
      default: ''
    }
  },
  data() {
    return {
      uploadImgList: [],
      userData: {}, // 用户信息
      textareaVal: '',
      showTextareaInputbox: false, // 显示输入框
      isTextareaFullscreen: false, // 输入框放大
      imageList: [], // 上传的图片链接
    };
  },
  created() {
    this.showTextareaInputbox = true;
    this.userData = this.$store.state.login.userData;
  },
  methods: {
    // 图片超出限制
    exceed() {
      this.$message.closeAll();
      this.$message.error(this.$t('HT.orderDetail.exceedError'));
    },
    // 点击放大
    changeExpansion() {
      if (this.isExpansion) {
        this.$emit('change-expansion');
      }
      this.isTextareaFullscreen = !this.isTextareaFullscreen;
    },
    // 刷新
    refresh() {
      this.$emit('refresh');
    },
    // 完结工单
    onClickOver() {
      this.$emit('over-order');
    },
    // 发送
    onClickSend() {
      if (!this.textareaVal && this.uploadImgList.length === 0) {
        this.$uxMessage.warning(this.$t('HT.orderDetail.placeholder'));
        return;
      }
      this.$uxLoading.show();
      // 上传图片至阿里云oss
      this.imageList = [];
      if (this.uploadImgList.length > 0) {
        this.$api.faceRecognition.getOssToken({bucket: 'BUCKET_WORK_ORDER'})
          .then(res => {
            if (res.code == 10000) {
              const promises = [];
              this.uploadImgList.forEach(item => {
                const p = this.ossClient(res.data, item);
                promises.push(p);
              });
              Promise.all(promises).then((res) => {
                this.imageList = res;
                this.apiReplyWorkerOrder();
              });
            }
          });
      } else {
        this.apiReplyWorkerOrder();
      }
    },
    // 上传至阿里云
    ossClient(params, file) {
      return new Promise((resolve) => {
        const _this = this;
        // 实例化OSS Client。
        const client = new OSS({
        // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
          contentType: '',
          region: params.region,
          // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
          accessKeyId: params.access_key_id,
          accessKeySecret: params.access_key_secret,
          // 从STS服务获取的安全令牌（SecurityToken）。
          stsToken: params.sts_token,
          refreshSTSToken: async () => {
          // 向您搭建的STS服务获取临时访问凭证。
            const info = await _this.getOssToken();
            // console.log('info', info);
            return {
              accessKeyId: info.access_key_id,
              accessKeySecret: info.access_key_secret,
              stsToken: info.sts_token,
            };
          },
          // 刷新临时访问凭证的时间间隔，单位为毫秒。
          refreshSTSTokenInterval: 3600,
          // 填写Bucket名称。
          bucket: params.bucket,
        });
        // file表示浏览器中需要上传的文件，支持HTML5 file和Blob类型。
        let fileName = file.name;
        fileName = fileName.substring(0, file.name.lastIndexOf('.'));
        fileName = `order_${fileName}_${new Date().getTime()}.jpg`;
        // fileName = 'order_' + fileName + '_' + new Date().getTime() + '.jpg';
        // console.log(file.name, fileName, file.raw);
        client
          .put(fileName, file.raw, {
            headers: {
              'Content-Type': 'image/jpg'
            }
          })
          .then(function (r1) {
            console.log('put success: %j', r1);
            return client.signatureUrl(fileName, { expires: 60 * 5});
          })
          .then(function (r2) {
            console.log('get success: %j', r2);
            resolve(fileName);
          })
          .catch(function (err) {
            console.error('error: %j', err);
          });
      });
    },
    getOssToken() {
      const _this = this;
      return new Promise(function(resolve) {
        _this.$api.faceRecognition.getOssToken({bucket: 'BUCKET_WORK_ORDER'})
          .then(res => {
            if (res.code == 10000) {
              resolve(res.data);
            }
          });
      });
    },
    apiReplyWorkerOrder() {
      const orderId = this.orderInfo.id;
      const { id, username } = this.userData;
      // 参数
      let params = new FormData();
      params.append('message', this.textareaVal);
      params.append('orderId', orderId);
      params.append('sendId', id);
      params.append('userName', username);
      this.imageList.forEach((item, idx) => {
        params.append(`image${idx + 1}`, item);
      });
      this.$api.workOrder
        .replyMsg(params)
        .then((res) => {
          if (res.code == 10000) {
            this.$uxMessage.success(this.$t('HT.orderDetail.sendSuccess'));
            this.refresh();
          }
        })
        .catch((err) => {
          const { sub_msg } = err.response.data || {};
          this.$uxMessage.error(sub_msg);
          this.$uxLoading.hide();
        });
    },
  },
  computed: {
    // 禁止上传
    isDisabledUpload() {
      return this.uploadImgList.length === 3;
    },
    // 行数
    autosize() {
      if (this.isTextareaFullscreen) {
        return { minRows: 14, maxRows: 14 };
      }
      return { minRows: 2, maxRows: 2 };
    },
    textareaPlaceholder() {
      return this.isOver ? this.$t('HT.orderDetail.text1') : this.$t('HT.orderDetail.text2');
    },
    // 已经关闭
    isOver() {
      return String(this.orderStatus) === '3';
    },
    isShowOverBtn() {
      return String(this.orderStatus) === '2';
    }
  },
  watch: {
    isExpansion(val) {
      if (val) {
        this.isTextareaFullscreen = false;
      }
    },
    isTextareaFullscreen() {
      this.showTextareaInputbox = false;
      this.$nextTick(() => {
        this.showTextareaInputbox = true;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.order-detail-textarea {
  box-sizing: border-box;
  position: relative;

  &.is-over {
    cursor: no-drop;

    .detail-textarea-box {
      pointer-events: none;
    }
  }

  &.textarea-expansion {
    min-height: 440px;

    &.detail-Expansion {
      min-height: 200px;
    }
  }

  .order-detail-textarea-header {
    text-align: right;
    padding-top: 4px;
  }

  .detail-textarea-upload {
    padding-top: 12px;
  }

  ::v-deep.detail-textarea-inputbox {
    .el-textarea__inner {
      border-color: transparent;
      padding: 5px 0;

      // 定义滚动条宽度
      &::-webkit-scrollbar {
        width: 5px;
      }

      // 定义滚动条轨道
      &::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: #f0f0f0;
      }

      // 定义滚动条滑块
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #dddee0;
      }
    }
  }

  .textarea-divider {
    display: block;
    width: 100%;
    height: 1px;
    margin: 10px 0 14px;
    background: $color-disable;
  }

  .detail-textarea-footer {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    .detail-textarea-footer-btns {
      text-align: right;

      .ux-button {
        margin-left: 8px;
      }
    }
  }
}
</style>
